import rust from "refractor/rust";
export default rust;